import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { logout as kcLogout } from '@functions/auth';
import { Button } from "@fc/devteam-components-library";
import useCleanRedux from '@customHooks/clean-redux/use-clean-redux';

const LogOutButton = (props:  {isHeader?: boolean} ) => {
    const { t } = useTranslation('sessionCard');
    const {cleanReducers} = useCleanRedux();
    const history = useNavigate();

    /**
     * Ends practitioner session
     */
    const logOutAction = async(path = "/") => {
        // dispatch logout redux action
        cleanReducers()
        // redirect to login
        history('/');
        try
        {
            await kcLogout();
            if(path !== "/")
            {
                navigateExternal(path);
            }
        }
        catch(error)
        {
            console.error("signOut error", error);
        }
    };

    const navigateExternal = (route: string) => {
        window.open(
            route,
            '_blank'
        )
    }

    return (
        props.isHeader ? 
        <Button
                    {...{
                        buttontext: t('logOutButton'),
                        buttontype: 'button',
                        action: () => logOutAction()
                    }}
                >
        </Button>
        :
        <div className="Menu__SectionsLogOut">
            <div className="Menu__SectionsItem-Logout" role="navigation" onClick={() => logOutAction()}>
                <div className="Menu__SectionsItemIcon">
                    <em className="fad fa-door-open"></em>
                </div>
                <p className="Menu__SectionsItemText">{t('logOutButton')}</p>
            </div>
        </div>
    );
};
export default LogOutButton;
